/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'angle-wide': {
    width: 16,
    height: 16,
    viewBox: '0 0 22 22',
    data: '<circle pid="0" cx="10.5" cy="11" r="9.5" _fill="#fff" _stroke="#f1f2f2" stroke-linecap="round" stroke-miterlimit="10" opacity=".2"/><path pid="1" d="M12.4 20.3l-1.9-7.8v-11" _fill="none" _stroke="#f1f2f2" stroke-linecap="round" stroke-miterlimit="10"/><path pid="2" d="M20 11a9.6 9.6 0 0 0-9.5-9.5v11l1.9 7.8A9.4 9.4 0 0 0 20 11z" _fill="none" _stroke="#f1f2f2" stroke-linecap="round" stroke-miterlimit="10"/>'
  }
})
